module.exports = __webpack_public_path__ + "img/logo-wq.c569cd18.png";